import { ICategoriesWithProductsList, IFinalProductProps } from "@/interfaces/products"

export const OrganizeProductsByCategory = (products: IFinalProductProps[], productsPT?: IFinalProductProps[]) => {

    let productsWithoutCategory: IFinalProductProps[] = []
    let productsInCategoryObject: ICategoriesWithProductsList = {}

    for(let i in products){

        let product = products[i]
        let productPT = productsPT ?  productsPT![i] : null

        if(product.categories?.length === 0){
            productsWithoutCategory.push(product)
        }else{

            for(let i in (product.categories || [])){
                
                let category = product.categories![i]
                let categoryPT = productPT ? productPT.categories![i] : {}

                let categoryName: string = category.name ? category.name : ''
                let categoryNamePT: string = categoryPT.name ? categoryPT.name : ''

                if(!productsInCategoryObject[categoryName]){
                    productsInCategoryObject[categoryName] = {
                        menu: categoryName,
                        categoryName,
                        categoryNamePT,
                        url: `/${categoryName}`,
                        products: [],
                        isCategory: true
                    }
                }

                productsInCategoryObject[categoryName].products.push(product)
            }
        }
    }
    let categoriesWithProducts = Object.keys(productsInCategoryObject).map( key => productsInCategoryObject[key])

    return {
        productsWithoutCategory,
        categoriesWithProducts
    }
}